import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=15e1bcfc&scoped=true&"
import script from "./contacts.vue?vue&type=script&lang=js&"
export * from "./contacts.vue?vue&type=script&lang=js&"
import style0 from "./contacts.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./contacts.vue?vue&type=style&index=1&id=15e1bcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e1bcfc",
  null
  
)

export default component.exports